import { SalesDashboardSubTitle, SalesDashboardTitle } from "../../Constant/SalesDashboard";
import { salesDashboardTitle } from "../../Constant/title";
import { useEffect } from "react";
import StackedBarChart from "./Barchart";
import TechnologyBarChart from "./TechnologyChart";

const SalesDashboard = () => {
  useEffect(() => {
    document.title = salesDashboardTitle;
  }, []);
  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h4 className="mb-1 fw-semibold">{SalesDashboardTitle}</h4>
          <small className="text-muted">{SalesDashboardSubTitle}</small>
        </div>
      </div>

      <div className="row g-3">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-3">
              <StackedBarChart />
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-3">
              <TechnologyBarChart />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesDashboard;

